import React from "react";
import moment from "moment";
import {Route, Switch, useHistory, useParams, useRouteMatch} from "react-router-dom";
import {IoMdArrowBack} from "react-icons/io"
import Blocks from "../blocks";
import AssignmentPng from '../../assets/images/assigmen.png';
import {getClassDetailsById} from "../../utils/reactQueries";

const tabList = ["My PlayList", "External Content", "Internal Content"];

const PageAddingAssignment = () => {
    const history = useHistory();
    const params = useParams();
    const {path, url} = useRouteMatch();
    const classId = params.classId;

    const {status, data, error, isFetching} = getClassDetailsById(classId);
    const classData = data?.data;

    const title = "You are creating an assignment for";
    let backURL = url.split("/");
    backURL.pop();
    backURL = backURL.concat("class-plan").join("/");
    const goToClassPlanPage = () => {
        const id = localStorage.getItem('classPlanID'); //get the class plan ID from the localstorage
        history.push(`${backURL}/${id}`)
    }

    return (
        <div className={"page PageAddingAssignment oveflow-y-auto"}>
            <div className="container mx-auto">
                <div className="flex lg:hidden items-center pt-16 pb-4 pl-4">
                    <IoMdArrowBack
                        onClick={() => goToClassPlanPage()}
                        size={20} className="mr-3 cursor-pointer"/>
                    <h3
                        className={
                            "text-xl text-center  font-['Poppins-Bold']"
                        }
                    >
                        {title}
                    </h3>
                </div>
                <ul
                    className={
                        "flex lg:hidden flex-wrap items-center justify-center gap-2 md:gap-8 mb-6 md:mb-14 text-sm"
                    }
                >
                    <li className={"flex items-center"}>
                        <i className="icon icon-menu"></i>
                        <p>{classData?.subject?.title}</p>
                    </li>
                    <li className={"flex items-center"}>
                        <i className="icon icon-git-commit"></i>
                        <p>{classData?.title}</p>
                    </li>
                    <li className={"flex items-center"}>
                        <p>Date - 12th Jan 2022</p>
                    </li>
                    <li className={"flex items-center"}>
                        <span className="icon icon-clock text-gray-500 mr-2 text-lg"></span>
                        <p>
                            Time-{moment.unix(classData?.start_time).format("HH:mmA")}-
                            {moment
                                .unix(classData?.start_time + classData?.duration_seconds)
                                .format("HH:mmA")}
                        </p>
                    </li>
                </ul>
                <div className="flex flex-col lg:flex-row items-center">
                    <div className="bgWrapper lg:flex justify-center items-center bg-white">
                        <img src={AssignmentPng} alt="" draggable={false}/>
                    </div>
                    <div
                        className="pageContent w-full max-w-2xl h-screen90 mx-auto md:mr-0 md:ml-auto  mb-4 bg-white p-4 rounded-xl">
                        <div className="hidden lg:flex items-center mb-4 ">
                            <IoMdArrowBack onClick={() => goToClassPlanPage()} size={30}
                                           className="mr-3 cursor-pointer"/>
                            <h1 className={"text-fs32 text-black font-bold mb-2 pr-12"}>
                                {title}
                            </h1>
                        </div>
                        <Blocks.ErrorBoundary>
                            <ul
                                className={
                                    "hidden lg:flex flex-col md:flex-row gap-4 md:gap-8 mb-6 md:mb-5 text-lg justify-center"
                                }
                            >
                                <li className={"flex items-center gap-2"}>
                                    <i className="icon icon-book-open"></i>
                                    <p>{classData?.subject?.title}</p>
                                </li>
                                <li className={"flex items-center gap-2"}>
                                    <i className="icon icon-git-commit"></i>
                                    <p>{classData?.title}</p>
                                </li>
                                <li className={"flex items-center gap-2"}>
                                    <i className="icon icon-git-commit"></i>
                                    <p>{classData?.subject?.description}</p>
                                </li>
                            </ul>

                            <div
                                id="contentWrapperBox"
                                className="flex flex-col flex-auto justify-between h-full contentWrapper relative"
                            >
                                <div className="flex-auto flex flex-col">
                                    <div className="flex flex-auto flex-col">
                                        <Switch>
                                            <Route path={`${path}/assignment-lists`}
                                                   component={Blocks.BlockAssignmentList}/>
                                            <Route path={`${path}/`} component={Blocks.BlockUploadAssignment}/>
                                            <Route path={`${path}/edit-assignment`}
                                                   component={Blocks.BlockUploadAssignment}/>
                                        </Switch>
                                    </div>
                                </div>

                            </div>
                        </Blocks.ErrorBoundary>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PageAddingAssignment;
